import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: string;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: any;
  /** The `Upload` scalar type represents a file upload. */
  Upload: any;
};


export type AreaByCoordinates = {
  __typename?: 'AreaByCoordinates';
  name?: Maybe<Scalars['String']>;
  distance: Scalars['Float'];
  avgPriceHouseBuy: Scalars['Float'];
  maxPriceHouseBuy?: Maybe<Scalars['Float']>;
  minPriceHouseBuy?: Maybe<Scalars['Float']>;
  avgPriceApartmentBuy: Scalars['Float'];
  maxPriceApartmentBuy?: Maybe<Scalars['Float']>;
  minPriceApartmentBuy?: Maybe<Scalars['Float']>;
  avgPriceHouseRent: Scalars['Float'];
  maxPriceHouseRent?: Maybe<Scalars['Float']>;
  minPriceHouseRent?: Maybe<Scalars['Float']>;
  avgPriceApartmentRent: Scalars['Float'];
  maxPriceApartmentRent?: Maybe<Scalars['Float']>;
  minPriceApartmentRent?: Maybe<Scalars['Float']>;
  stateName?: Maybe<Scalars['String']>;
  cityName?: Maybe<Scalars['String']>;
  districtName?: Maybe<Scalars['String']>;
  districtSmallName?: Maybe<Scalars['String']>;
  url: Scalars['String'];
  polygon: Scalars['JSON'];
  circle: Scalars['JSON'];
  center: Scalars['JSON'];
};

export type AreasByCoordinates = {
  __typename?: 'AreasByCoordinates';
  areas?: Maybe<Array<AreaByCoordinates>>;
  lat: Scalars['Float'];
  long: Scalars['Float'];
  radius: Scalars['Float'];
};

export type Bounds = {
  ne: Coordinates;
  sw: Coordinates;
};

export enum CacheControlScope {
  Public = 'PUBLIC',
  Private = 'PRIVATE'
}

export type Coordinates = {
  lat: Scalars['Float'];
  long: Scalars['Float'];
};


export type InfoByArea = {
  __typename?: 'InfoByArea';
  avgPriceHouseBuy: Scalars['Float'];
  avgPriceApartmentBuy: Scalars['Float'];
  maxPriceHouseBuy: Scalars['Float'];
  minPriceHouseBuy: Scalars['Float'];
  maxPriceApartmentBuy: Scalars['Float'];
  minPriceApartmentBuy: Scalars['Float'];
  avgPriceHouseRent: Scalars['Float'];
  maxPriceHouseRent: Scalars['Float'];
  minPriceHouseRent: Scalars['Float'];
  avgPriceApartmentRent: Scalars['Float'];
  maxPriceApartmentRent: Scalars['Float'];
  minPriceApartmentRent: Scalars['Float'];
  description: Scalars['String'];
  seoDescription?: Maybe<Scalars['String']>;
  seoUrl: Scalars['Boolean'];
  center: Scalars['JSON'];
  layer: Scalars['String'];
  name: Scalars['String'];
};

export type InfoByCoordinates = {
  __typename?: 'InfoByCoordinates';
  address?: Maybe<Scalars['JSON']>;
  avgPriceHouseBuy?: Maybe<Scalars['Float']>;
  maxPriceHouseBuy?: Maybe<Scalars['Float']>;
  minPriceHouseBuy?: Maybe<Scalars['Float']>;
  avgPriceApartmentBuy?: Maybe<Scalars['Float']>;
  maxPriceApartmentBuy?: Maybe<Scalars['Float']>;
  minPriceApartmentBuy?: Maybe<Scalars['Float']>;
  avgPriceHouseRent?: Maybe<Scalars['Float']>;
  maxPriceHouseRent?: Maybe<Scalars['Float']>;
  minPriceHouseRent?: Maybe<Scalars['Float']>;
  avgPriceApartmentRent?: Maybe<Scalars['Float']>;
  maxPriceApartmentRent?: Maybe<Scalars['Float']>;
  minPriceApartmentRent?: Maybe<Scalars['Float']>;
};



export enum Layer {
  Country = 'country',
  State = 'state',
  County = 'county',
  City = 'city',
  District = 'district',
  DistrictSmall = 'district_small'
}

export type LayersByCoordinates = {
  __typename?: 'LayersByCoordinates';
  id?: Maybe<Scalars['Int']>;
  stateName?: Maybe<Scalars['String']>;
  cityName?: Maybe<Scalars['String']>;
  districtName?: Maybe<Scalars['String']>;
  districtSmallName?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type LayersByUrl = {
  __typename?: 'LayersByUrl';
  id?: Maybe<Scalars['Int']>;
  stateName?: Maybe<Scalars['String']>;
  stateNameSlug?: Maybe<Scalars['String']>;
  cityNameSlug?: Maybe<Scalars['String']>;
  cityName?: Maybe<Scalars['String']>;
  districtName?: Maybe<Scalars['String']>;
  districtNameSlug?: Maybe<Scalars['String']>;
  districtSmallName?: Maybe<Scalars['String']>;
  districtSmallNameSlug?: Maybe<Scalars['String']>;
  url: Scalars['String'];
};

export type NearbyArea = {
  __typename?: 'NearbyArea';
  name: Scalars['String'];
  avgPriceHouseBuy?: Maybe<Scalars['Float']>;
  avgPriceApartmentBuy?: Maybe<Scalars['Float']>;
  maxPriceHouseBuy?: Maybe<Scalars['Float']>;
  minPriceHouseBuy?: Maybe<Scalars['Float']>;
  maxPriceApartmentBuy?: Maybe<Scalars['Float']>;
  minPriceApartmentBuy?: Maybe<Scalars['Float']>;
  avgPriceHouseRent?: Maybe<Scalars['Float']>;
  maxPriceHouseRent?: Maybe<Scalars['Float']>;
  minPriceHouseRent?: Maybe<Scalars['Float']>;
  avgPriceApartmentRent?: Maybe<Scalars['Float']>;
  maxPriceApartmentRent?: Maybe<Scalars['Float']>;
  minPriceApartmentRent?: Maybe<Scalars['Float']>;
  center: Scalars['JSON'];
  hasChildLayer: Scalars['Boolean'];
  url: Scalars['String'];
  isCity: Scalars['Boolean'];
  seoUrl: Scalars['Boolean'];
};

export type NearbyAreasByArea = {
  __typename?: 'NearbyAreasByArea';
  nearbyAreas: Array<NearbyArea>;
  layer: Scalars['String'];
  subLayer?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type OfferingsAmount = {
  __typename?: 'OfferingsAmount';
  housesToBuy?: Maybe<Scalars['Int']>;
  apartmentsToBuy?: Maybe<Scalars['Int']>;
};

export type ParentSearch = {
  state?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  district?: Maybe<Scalars['String']>;
  districtSmall?: Maybe<Scalars['String']>;
};

export type Properties = {
  __typename?: 'Properties';
  properties?: Maybe<Array<Maybe<Property>>>;
  layer?: Maybe<Layer>;
};

export type Property = {
  __typename?: 'Property';
  address: Scalars['String'];
  etage?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  priceSqM?: Maybe<Scalars['Float']>;
  rooms?: Maybe<Scalars['Float']>;
  sqM?: Maybe<Scalars['Float']>;
  lat: Scalars['Float'];
  lng: Scalars['Float'];
  onlineSince?: Maybe<Scalars['Date']>;
  offlineSince?: Maybe<Scalars['Date']>;
};

export type Query = {
  __typename?: 'Query';
  infoByArea?: Maybe<InfoByArea>;
  subAreasByArea?: Maybe<SubAreasByArea>;
  nearbyAreasByArea?: Maybe<NearbyAreasByArea>;
  infoByCoordinates?: Maybe<InfoByCoordinates>;
  areasByCoordinates?: Maybe<AreasByCoordinates>;
  layersByCoordinates?: Maybe<LayersByCoordinates>;
  layersByUrl?: Maybe<LayersByUrl>;
  topCities: Array<TopCity>;
  properties?: Maybe<Properties>;
  trends: Array<Trend>;
  offeringsAmount?: Maybe<OfferingsAmount>;
  sitemapUrls: Array<Scalars['String']>;
};


export type QueryInfoByAreaArgs = {
  layer: Layer;
  name: Scalars['String'];
  parentSearch?: Maybe<ParentSearch>;
};


export type QuerySubAreasByAreaArgs = {
  layer: Layer;
  name: Scalars['String'];
  parentSearch?: Maybe<ParentSearch>;
};


export type QueryNearbyAreasByAreaArgs = {
  layer: Layer;
  name: Scalars['String'];
  parentSearch?: Maybe<ParentSearch>;
};


export type QueryInfoByCoordinatesArgs = {
  lat: Scalars['Float'];
  long: Scalars['Float'];
};


export type QueryAreasByCoordinatesArgs = {
  lat: Scalars['Float'];
  long: Scalars['Float'];
  radius?: Maybe<Scalars['Int']>;
};


export type QueryLayersByCoordinatesArgs = {
  lat: Scalars['Float'];
  long: Scalars['Float'];
  layer: Layer;
};


export type QueryLayersByUrlArgs = {
  url: Scalars['String'];
};


export type QueryPropertiesArgs = {
  bounds: Bounds;
};


export type QueryTrendsArgs = {
  layer: Layer;
  name: Scalars['String'];
  parentSearch?: Maybe<ParentSearch>;
};


export type QueryOfferingsAmountArgs = {
  layer: Layer;
  name: Scalars['String'];
  parentSearch?: Maybe<ParentSearch>;
};

export type SubArea = {
  __typename?: 'SubArea';
  name: Scalars['String'];
  avgPriceHouseBuy?: Maybe<Scalars['Float']>;
  avgPriceApartmentBuy?: Maybe<Scalars['Float']>;
  maxPriceHouseBuy?: Maybe<Scalars['Float']>;
  minPriceHouseBuy?: Maybe<Scalars['Float']>;
  maxPriceApartmentBuy?: Maybe<Scalars['Float']>;
  minPriceApartmentBuy?: Maybe<Scalars['Float']>;
  avgPriceHouseRent?: Maybe<Scalars['Float']>;
  maxPriceHouseRent?: Maybe<Scalars['Float']>;
  minPriceHouseRent?: Maybe<Scalars['Float']>;
  avgPriceApartmentRent?: Maybe<Scalars['Float']>;
  maxPriceApartmentRent?: Maybe<Scalars['Float']>;
  minPriceApartmentRent?: Maybe<Scalars['Float']>;
  center: Scalars['JSON'];
  url?: Maybe<Scalars['String']>;
  seoUrl: Scalars['Boolean'];
};

export type SubAreasByArea = {
  __typename?: 'SubAreasByArea';
  subAreas: Array<SubArea>;
};

export type TopCity = {
  __typename?: 'TopCity';
  stateName?: Maybe<Scalars['String']>;
  cityName?: Maybe<Scalars['String']>;
  avgPriceHouseBuy: Scalars['Float'];
  avgPriceApartmentBuy: Scalars['Float'];
  avgPriceHouseRent: Scalars['Float'];
  avgPriceApartmentRent: Scalars['Float'];
  url: Scalars['String'];
  seoUrl: Scalars['Boolean'];
};

export type Trend = {
  __typename?: 'Trend';
  quarter: TrendQuarter;
  avgPrice: Scalars['Float'];
  changeRate: Scalars['Float'];
};

export type TrendQuarter = {
  __typename?: 'TrendQuarter';
  year: Scalars['Int'];
  number: Scalars['Int'];
};


export type GetAreasByCoordinatesQueryVariables = Exact<{
  lat: Scalars['Float'];
  lng: Scalars['Float'];
}>;


export type GetAreasByCoordinatesQuery = (
  { __typename?: 'Query' }
  & { areasByCoordinates?: Maybe<(
    { __typename?: 'AreasByCoordinates' }
    & Pick<AreasByCoordinates, 'lat' | 'long' | 'radius'>
    & { areas?: Maybe<Array<(
      { __typename?: 'AreaByCoordinates' }
      & Pick<AreaByCoordinates, 'stateName' | 'cityName' | 'districtName' | 'districtSmallName' | 'url' | 'distance' | 'avgPriceHouseBuy' | 'avgPriceApartmentBuy' | 'maxPriceHouseBuy' | 'minPriceHouseBuy' | 'maxPriceApartmentBuy' | 'minPriceApartmentBuy' | 'avgPriceHouseRent' | 'avgPriceApartmentRent' | 'maxPriceHouseRent' | 'minPriceHouseRent' | 'maxPriceApartmentRent' | 'minPriceApartmentRent' | 'polygon'>
    )>> }
  )> }
);

export type GetSubAreasByAreaQueryVariables = Exact<{
  layer: Layer;
  name: Scalars['String'];
  parentSearch?: Maybe<ParentSearch>;
}>;


export type GetSubAreasByAreaQuery = (
  { __typename?: 'Query' }
  & { subAreasByArea?: Maybe<(
    { __typename?: 'SubAreasByArea' }
    & { subAreas: Array<(
      { __typename?: 'SubArea' }
      & Pick<SubArea, 'name' | 'avgPriceHouseBuy' | 'avgPriceApartmentBuy' | 'maxPriceHouseBuy' | 'minPriceHouseBuy' | 'maxPriceApartmentBuy' | 'minPriceApartmentBuy' | 'avgPriceHouseRent' | 'maxPriceHouseRent' | 'minPriceHouseRent' | 'avgPriceApartmentRent' | 'maxPriceApartmentRent' | 'minPriceApartmentRent' | 'center' | 'url' | 'seoUrl'>
    )> }
  )> }
);

export type GetLayersByCoordinatesQueryVariables = Exact<{
  lat: Scalars['Float'];
  lng: Scalars['Float'];
  layer: Layer;
}>;


export type GetLayersByCoordinatesQuery = (
  { __typename?: 'Query' }
  & { layersByCoordinates?: Maybe<(
    { __typename?: 'LayersByCoordinates' }
    & Pick<LayersByCoordinates, 'stateName' | 'cityName' | 'districtName' | 'districtSmallName' | 'url'>
  )> }
);

export type GetLayersByUrlQueryVariables = Exact<{
  url: Scalars['String'];
}>;


export type GetLayersByUrlQuery = (
  { __typename?: 'Query' }
  & { layersByUrl?: Maybe<(
    { __typename?: 'LayersByUrl' }
    & Pick<LayersByUrl, 'id' | 'url' | 'stateName' | 'stateNameSlug' | 'cityName' | 'cityNameSlug' | 'districtName' | 'districtNameSlug' | 'districtSmallName' | 'districtSmallNameSlug'>
  )> }
);

export type GetNearbyAreasQueryVariables = Exact<{
  layer: Layer;
  name: Scalars['String'];
  parentSearch?: Maybe<ParentSearch>;
}>;


export type GetNearbyAreasQuery = (
  { __typename?: 'Query' }
  & { nearbyAreasByArea?: Maybe<(
    { __typename?: 'NearbyAreasByArea' }
    & Pick<NearbyAreasByArea, 'name' | 'layer'>
    & { nearbyAreas: Array<(
      { __typename?: 'NearbyArea' }
      & Pick<NearbyArea, 'name' | 'avgPriceApartmentBuy' | 'avgPriceApartmentRent' | 'avgPriceHouseBuy' | 'avgPriceHouseRent' | 'url' | 'seoUrl'>
    )> }
  )> }
);

export type GetInfoByAreaQueryVariables = Exact<{
  layer: Layer;
  name: Scalars['String'];
  parentSearch?: Maybe<ParentSearch>;
}>;


export type GetInfoByAreaQuery = (
  { __typename?: 'Query' }
  & { topCities: Array<(
    { __typename?: 'TopCity' }
    & Pick<TopCity, 'stateName' | 'cityName' | 'avgPriceHouseBuy' | 'avgPriceApartmentBuy' | 'avgPriceHouseRent' | 'avgPriceApartmentRent' | 'url' | 'seoUrl'>
  )>, infoByArea?: Maybe<(
    { __typename?: 'InfoByArea' }
    & Pick<InfoByArea, 'name' | 'avgPriceHouseBuy' | 'avgPriceApartmentBuy' | 'maxPriceHouseBuy' | 'minPriceHouseBuy' | 'maxPriceApartmentBuy' | 'minPriceApartmentBuy' | 'avgPriceHouseRent' | 'avgPriceApartmentRent' | 'maxPriceHouseRent' | 'minPriceHouseRent' | 'maxPriceApartmentRent' | 'minPriceApartmentRent' | 'center' | 'description' | 'seoDescription' | 'seoUrl'>
  )>, offeringsAmount?: Maybe<(
    { __typename?: 'OfferingsAmount' }
    & Pick<OfferingsAmount, 'housesToBuy' | 'apartmentsToBuy'>
  )> }
);

export type GetPropertiesByCoordinatesQueryVariables = Exact<{
  bounds: Bounds;
}>;


export type GetPropertiesByCoordinatesQuery = (
  { __typename?: 'Query' }
  & { properties?: Maybe<(
    { __typename?: 'Properties' }
    & { properties?: Maybe<Array<Maybe<(
      { __typename?: 'Property' }
      & Pick<Property, 'address' | 'etage' | 'price' | 'priceSqM' | 'onlineSince' | 'rooms' | 'sqM' | 'lat' | 'lng'>
    )>>> }
  )> }
);

export type GetTrendsQueryVariables = Exact<{
  layer: Layer;
  name: Scalars['String'];
  parentSearch?: Maybe<ParentSearch>;
}>;


export type GetTrendsQuery = (
  { __typename?: 'Query' }
  & { trends: Array<(
    { __typename?: 'Trend' }
    & Pick<Trend, 'avgPrice'>
    & { quarter: (
      { __typename?: 'TrendQuarter' }
      & Pick<TrendQuarter, 'year' | 'number'>
    ) }
  )> }
);


export const GetAreasByCoordinatesDocument = gql`
    query getAreasByCoordinates($lat: Float!, $lng: Float!) {
  areasByCoordinates(lat: $lat, long: $lng, radius: 500) {
    lat
    long
    radius
    areas {
      stateName
      cityName
      districtName
      districtSmallName
      url
      distance
      avgPriceHouseBuy
      avgPriceApartmentBuy
      maxPriceHouseBuy
      minPriceHouseBuy
      maxPriceApartmentBuy
      minPriceApartmentBuy
      avgPriceHouseRent
      avgPriceApartmentRent
      maxPriceHouseRent
      minPriceHouseRent
      maxPriceApartmentRent
      minPriceApartmentRent
      polygon
    }
  }
}
    `;

/**
 * __useGetAreasByCoordinatesQuery__
 *
 * To run a query within a React component, call `useGetAreasByCoordinatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAreasByCoordinatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAreasByCoordinatesQuery({
 *   variables: {
 *      lat: // value for 'lat'
 *      lng: // value for 'lng'
 *   },
 * });
 */
export function useGetAreasByCoordinatesQuery(baseOptions: Apollo.QueryHookOptions<GetAreasByCoordinatesQuery, GetAreasByCoordinatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAreasByCoordinatesQuery, GetAreasByCoordinatesQueryVariables>(GetAreasByCoordinatesDocument, options);
      }
export function useGetAreasByCoordinatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAreasByCoordinatesQuery, GetAreasByCoordinatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAreasByCoordinatesQuery, GetAreasByCoordinatesQueryVariables>(GetAreasByCoordinatesDocument, options);
        }
export type GetAreasByCoordinatesQueryHookResult = ReturnType<typeof useGetAreasByCoordinatesQuery>;
export type GetAreasByCoordinatesLazyQueryHookResult = ReturnType<typeof useGetAreasByCoordinatesLazyQuery>;
export type GetAreasByCoordinatesQueryResult = Apollo.QueryResult<GetAreasByCoordinatesQuery, GetAreasByCoordinatesQueryVariables>;
export const GetSubAreasByAreaDocument = gql`
    query getSubAreasByArea($layer: Layer!, $name: String!, $parentSearch: ParentSearch) {
  subAreasByArea(layer: $layer, name: $name, parentSearch: $parentSearch) {
    subAreas {
      name
      avgPriceHouseBuy
      avgPriceApartmentBuy
      maxPriceHouseBuy
      minPriceHouseBuy
      maxPriceApartmentBuy
      minPriceApartmentBuy
      avgPriceHouseRent
      maxPriceHouseRent
      minPriceHouseRent
      avgPriceApartmentRent
      maxPriceApartmentRent
      minPriceApartmentRent
      center
      url
      seoUrl
    }
  }
}
    `;

/**
 * __useGetSubAreasByAreaQuery__
 *
 * To run a query within a React component, call `useGetSubAreasByAreaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubAreasByAreaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubAreasByAreaQuery({
 *   variables: {
 *      layer: // value for 'layer'
 *      name: // value for 'name'
 *      parentSearch: // value for 'parentSearch'
 *   },
 * });
 */
export function useGetSubAreasByAreaQuery(baseOptions: Apollo.QueryHookOptions<GetSubAreasByAreaQuery, GetSubAreasByAreaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubAreasByAreaQuery, GetSubAreasByAreaQueryVariables>(GetSubAreasByAreaDocument, options);
      }
export function useGetSubAreasByAreaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubAreasByAreaQuery, GetSubAreasByAreaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubAreasByAreaQuery, GetSubAreasByAreaQueryVariables>(GetSubAreasByAreaDocument, options);
        }
export type GetSubAreasByAreaQueryHookResult = ReturnType<typeof useGetSubAreasByAreaQuery>;
export type GetSubAreasByAreaLazyQueryHookResult = ReturnType<typeof useGetSubAreasByAreaLazyQuery>;
export type GetSubAreasByAreaQueryResult = Apollo.QueryResult<GetSubAreasByAreaQuery, GetSubAreasByAreaQueryVariables>;
export const GetLayersByCoordinatesDocument = gql`
    query getLayersByCoordinates($lat: Float!, $lng: Float!, $layer: Layer!) {
  layersByCoordinates(lat: $lat, long: $lng, layer: $layer) {
    stateName
    cityName
    districtName
    districtSmallName
    url
  }
}
    `;

/**
 * __useGetLayersByCoordinatesQuery__
 *
 * To run a query within a React component, call `useGetLayersByCoordinatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLayersByCoordinatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLayersByCoordinatesQuery({
 *   variables: {
 *      lat: // value for 'lat'
 *      lng: // value for 'lng'
 *      layer: // value for 'layer'
 *   },
 * });
 */
export function useGetLayersByCoordinatesQuery(baseOptions: Apollo.QueryHookOptions<GetLayersByCoordinatesQuery, GetLayersByCoordinatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLayersByCoordinatesQuery, GetLayersByCoordinatesQueryVariables>(GetLayersByCoordinatesDocument, options);
      }
export function useGetLayersByCoordinatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLayersByCoordinatesQuery, GetLayersByCoordinatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLayersByCoordinatesQuery, GetLayersByCoordinatesQueryVariables>(GetLayersByCoordinatesDocument, options);
        }
export type GetLayersByCoordinatesQueryHookResult = ReturnType<typeof useGetLayersByCoordinatesQuery>;
export type GetLayersByCoordinatesLazyQueryHookResult = ReturnType<typeof useGetLayersByCoordinatesLazyQuery>;
export type GetLayersByCoordinatesQueryResult = Apollo.QueryResult<GetLayersByCoordinatesQuery, GetLayersByCoordinatesQueryVariables>;
export const GetLayersByUrlDocument = gql`
    query getLayersByUrl($url: String!) {
  layersByUrl(url: $url) {
    id
    url
    stateName
    stateNameSlug
    cityName
    cityNameSlug
    districtName
    districtNameSlug
    districtSmallName
    districtSmallNameSlug
  }
}
    `;

/**
 * __useGetLayersByUrlQuery__
 *
 * To run a query within a React component, call `useGetLayersByUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLayersByUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLayersByUrlQuery({
 *   variables: {
 *      url: // value for 'url'
 *   },
 * });
 */
export function useGetLayersByUrlQuery(baseOptions: Apollo.QueryHookOptions<GetLayersByUrlQuery, GetLayersByUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLayersByUrlQuery, GetLayersByUrlQueryVariables>(GetLayersByUrlDocument, options);
      }
export function useGetLayersByUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLayersByUrlQuery, GetLayersByUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLayersByUrlQuery, GetLayersByUrlQueryVariables>(GetLayersByUrlDocument, options);
        }
export type GetLayersByUrlQueryHookResult = ReturnType<typeof useGetLayersByUrlQuery>;
export type GetLayersByUrlLazyQueryHookResult = ReturnType<typeof useGetLayersByUrlLazyQuery>;
export type GetLayersByUrlQueryResult = Apollo.QueryResult<GetLayersByUrlQuery, GetLayersByUrlQueryVariables>;
export const GetNearbyAreasDocument = gql`
    query getNearbyAreas($layer: Layer!, $name: String!, $parentSearch: ParentSearch) {
  nearbyAreasByArea(layer: $layer, name: $name, parentSearch: $parentSearch) {
    name
    layer
    nearbyAreas {
      name
      avgPriceApartmentBuy
      avgPriceApartmentRent
      avgPriceHouseBuy
      avgPriceHouseRent
      url
      seoUrl
    }
  }
}
    `;

/**
 * __useGetNearbyAreasQuery__
 *
 * To run a query within a React component, call `useGetNearbyAreasQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNearbyAreasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNearbyAreasQuery({
 *   variables: {
 *      layer: // value for 'layer'
 *      name: // value for 'name'
 *      parentSearch: // value for 'parentSearch'
 *   },
 * });
 */
export function useGetNearbyAreasQuery(baseOptions: Apollo.QueryHookOptions<GetNearbyAreasQuery, GetNearbyAreasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNearbyAreasQuery, GetNearbyAreasQueryVariables>(GetNearbyAreasDocument, options);
      }
export function useGetNearbyAreasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNearbyAreasQuery, GetNearbyAreasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNearbyAreasQuery, GetNearbyAreasQueryVariables>(GetNearbyAreasDocument, options);
        }
export type GetNearbyAreasQueryHookResult = ReturnType<typeof useGetNearbyAreasQuery>;
export type GetNearbyAreasLazyQueryHookResult = ReturnType<typeof useGetNearbyAreasLazyQuery>;
export type GetNearbyAreasQueryResult = Apollo.QueryResult<GetNearbyAreasQuery, GetNearbyAreasQueryVariables>;
export const GetInfoByAreaDocument = gql`
    query getInfoByArea($layer: Layer!, $name: String!, $parentSearch: ParentSearch) {
  topCities {
    stateName
    cityName
    avgPriceHouseBuy
    avgPriceApartmentBuy
    avgPriceHouseRent
    avgPriceApartmentRent
    url
    seoUrl
  }
  infoByArea(layer: $layer, name: $name, parentSearch: $parentSearch) {
    name
    avgPriceHouseBuy
    avgPriceApartmentBuy
    maxPriceHouseBuy
    minPriceHouseBuy
    maxPriceApartmentBuy
    minPriceApartmentBuy
    avgPriceHouseRent
    avgPriceApartmentRent
    maxPriceHouseRent
    minPriceHouseRent
    maxPriceApartmentRent
    minPriceApartmentRent
    center
    description
    seoDescription
    seoUrl
  }
  offeringsAmount(layer: $layer, name: $name, parentSearch: $parentSearch) {
    housesToBuy
    apartmentsToBuy
  }
}
    `;

/**
 * __useGetInfoByAreaQuery__
 *
 * To run a query within a React component, call `useGetInfoByAreaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInfoByAreaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInfoByAreaQuery({
 *   variables: {
 *      layer: // value for 'layer'
 *      name: // value for 'name'
 *      parentSearch: // value for 'parentSearch'
 *   },
 * });
 */
export function useGetInfoByAreaQuery(baseOptions: Apollo.QueryHookOptions<GetInfoByAreaQuery, GetInfoByAreaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInfoByAreaQuery, GetInfoByAreaQueryVariables>(GetInfoByAreaDocument, options);
      }
export function useGetInfoByAreaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInfoByAreaQuery, GetInfoByAreaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInfoByAreaQuery, GetInfoByAreaQueryVariables>(GetInfoByAreaDocument, options);
        }
export type GetInfoByAreaQueryHookResult = ReturnType<typeof useGetInfoByAreaQuery>;
export type GetInfoByAreaLazyQueryHookResult = ReturnType<typeof useGetInfoByAreaLazyQuery>;
export type GetInfoByAreaQueryResult = Apollo.QueryResult<GetInfoByAreaQuery, GetInfoByAreaQueryVariables>;
export const GetPropertiesByCoordinatesDocument = gql`
    query getPropertiesByCoordinates($bounds: Bounds!) {
  properties(bounds: $bounds) {
    properties {
      address
      etage
      price
      priceSqM
      onlineSince
      rooms
      sqM
      lat
      lng
    }
  }
}
    `;

/**
 * __useGetPropertiesByCoordinatesQuery__
 *
 * To run a query within a React component, call `useGetPropertiesByCoordinatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPropertiesByCoordinatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPropertiesByCoordinatesQuery({
 *   variables: {
 *      bounds: // value for 'bounds'
 *   },
 * });
 */
export function useGetPropertiesByCoordinatesQuery(baseOptions: Apollo.QueryHookOptions<GetPropertiesByCoordinatesQuery, GetPropertiesByCoordinatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPropertiesByCoordinatesQuery, GetPropertiesByCoordinatesQueryVariables>(GetPropertiesByCoordinatesDocument, options);
      }
export function useGetPropertiesByCoordinatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPropertiesByCoordinatesQuery, GetPropertiesByCoordinatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPropertiesByCoordinatesQuery, GetPropertiesByCoordinatesQueryVariables>(GetPropertiesByCoordinatesDocument, options);
        }
export type GetPropertiesByCoordinatesQueryHookResult = ReturnType<typeof useGetPropertiesByCoordinatesQuery>;
export type GetPropertiesByCoordinatesLazyQueryHookResult = ReturnType<typeof useGetPropertiesByCoordinatesLazyQuery>;
export type GetPropertiesByCoordinatesQueryResult = Apollo.QueryResult<GetPropertiesByCoordinatesQuery, GetPropertiesByCoordinatesQueryVariables>;
export const GetTrendsDocument = gql`
    query getTrends($layer: Layer!, $name: String!, $parentSearch: ParentSearch) {
  trends(layer: $layer, name: $name, parentSearch: $parentSearch) {
    quarter {
      year
      number
    }
    avgPrice
  }
}
    `;

/**
 * __useGetTrendsQuery__
 *
 * To run a query within a React component, call `useGetTrendsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrendsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrendsQuery({
 *   variables: {
 *      layer: // value for 'layer'
 *      name: // value for 'name'
 *      parentSearch: // value for 'parentSearch'
 *   },
 * });
 */
export function useGetTrendsQuery(baseOptions: Apollo.QueryHookOptions<GetTrendsQuery, GetTrendsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTrendsQuery, GetTrendsQueryVariables>(GetTrendsDocument, options);
      }
export function useGetTrendsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTrendsQuery, GetTrendsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTrendsQuery, GetTrendsQueryVariables>(GetTrendsDocument, options);
        }
export type GetTrendsQueryHookResult = ReturnType<typeof useGetTrendsQuery>;
export type GetTrendsLazyQueryHookResult = ReturnType<typeof useGetTrendsLazyQuery>;
export type GetTrendsQueryResult = Apollo.QueryResult<GetTrendsQuery, GetTrendsQueryVariables>;